<template>
  <v-container fluid>
    <template>
      <v-carousel :show-arrows="false">
        <v-carousel-item v-for="(post, i) in imageList" :key="i" :src="post.url"></v-carousel-item>
      </v-carousel>
      <v-gallery :images="imageList" />
      <v-row>
        <v-col v-for="(p,id) in videoList" :key="id" cols="12" sm="6" lg="4">
          <video-player
            class="vjs-custom-skin"
            ref="videoPlayer"
            :options="p.url"
            :playsinline="true"
          />
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "AerialContent",
  computed: {
    ...mapState(["loadingAerial", "aerial"]),
    imageList() {
      let list = [];
      let count = 0;
      this.aerial.forEach(element => {
        if (!element.video) {
          list.push({ title: "Image" + count, url: element.mediaUrl });
          count++;
        }
      });
      return list;
    },
    videoList() {
      let list = [];
      this.aerial.forEach(element => {
        if (element.video) {
          let x = {
            height: "360",
            autoplay: false,
            muted: true,
            language: "en",
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            sources: [
              {
                type: "video/mp4",
                src: element.mediaUrl
              }
            ]
          };
          list.push({ url: x });
        }
      });
      return list;
    }
  },
  mounted() {
    if (!this.aerial.length) this.$store.dispatch("cargarAerial");
  }
};
</script>

<style scoped>
/deep/.url {
  text-decoration-line: none;
  color: #b80b0b !important;
  font-style: italic;
}

.title {
  text-align: justify;
  font-size: 3.2vmin !important;
  text-decoration-line: underline;
  word-break: break-word;
}

/deep/.video-js {
  margin: auto;
  max-width: 100%;
  max-height: 256px;
}

.subtitle {
  text-align: start;
  font-size: 2.2vmin !important;
  word-break: break-word;
}

.text {
  text-align: justify;
  padding-right: 1rem;
  padding-left: 1rem;
  font-size: 2.4vmin !important;
  word-break: break-word;
  margin-bottom: 0;
}

.cols {
  padding-top: 0;
}

.v-carousel {
  width: 60vw !important;
  margin: auto;
}
</style>